import { Box, Stack } from '@mui/material';
import { Customer } from 'api/user-domain/user-domain.types';
import CustomerAdditionalInfo from './customer-additional-info.component';

const CustomerSubheader = ({ customer }: { customer: Partial<Customer> }) => {
  return (
    <Stack spacing={0.5}>
      <Box sx={{ wordBreak: 'break-all' }}>{customer.email}</Box>
      <CustomerAdditionalInfo customer={customer} />
    </Stack>
  );
};
export default CustomerSubheader;
